const validarPermiso=(item)=>{
    var permisos = JSON.parse(localStorage.getItem('info')).PERMISO;
    if(permisos===null){
        return false
    }else{
        var permiso = permisos.split(':');
        var clspermiso = (permiso.indexOf(item) >= 0 || permiso.indexOf('0') >= 0) ? true :false;
        return clspermiso;
    }
}

export default {validarPermiso};